import { Input } from '@nextgen-web-framework/all';
import { useLocale, useFormatDate } from '../../../utils/customHooks';
import { parseString } from '../../../utils/helper';
import { MyAccountFieldType } from '../../../utils/types/enum';
import PhoneNumberDisplay from '../PhoneNumberDisplay/PhoneNumberDisplay';
import { DisplayFieldProps } from './types/propTypes';
import styles from './DisplayField.module.scss';

export const DisplayField = ({
  fieldName,
  label,
  value,
  content,
  type,
  showAsInput,
  dateLocale,
}: DisplayFieldProps) => {
  const locale = useLocale();
  const { formatDate } = useFormatDate();

  let dispValue: string | null = null;

  if (type === MyAccountFieldType.DATE && value !== 'undefined' && value) {
    // TH Lunar date will handle in formatDate with locale
    const formattedDate = formatDate(value, dateLocale ?? locale);
    dispValue = formattedDate ? formattedDate.split(',')[0] : null;
  } else {
    // For non-date types or when value is undefined, null, or empty
    dispValue = value || null;
  }

  return showAsInput ? (
    <Input
      name={parseString(fieldName)}
      label={label}
      value={parseString(dispValue)}
      readOnly={true}
      data-testid="display-field-input-testid"
    />
  ) : (
    <div className={styles['display-field']}>
      <div className={styles['display-field-label']} data-testid="display-field-label-testid">
        {label}
      </div>
      <div className={styles['display-field-value']} data-testid="display-field-value-testid">
        {!content &&
          (type === MyAccountFieldType.PHONE ? (
            <PhoneNumberDisplay phoneNumber={dispValue ?? '-'} />
          ) : (
            parseString(dispValue, '-')
          ))}
        {content}
      </div>
    </div>
  );
};
